<header class="menu-bar">
  <div class="img-section">
    <a id="cinoi-logo" target="_blank" href="https://www.um.edu.uy/cinoi"><img class="cinoi-logo" src="assets/img/cinoi-logo.png"
                                                               alt="logo cinoi"></a>
    <a id="anii-logo" target="_blank" href="https://www.anii.org.uy/"><img class="anii-logo" src="assets/img/anii-logo.jpg"
                                                           alt="logo anii"></a>
  </div>

  <nav class="nav-bar">
    <div class="nav-bar-container">
      <a [ngClass]="{'current-link' : compareRouterValue('/home')}" routerLink="/home">Inicio</a>
      <a [ngClass]="{'current-link' : compareRouterValue('/sobre-el-proyecto')}" routerLink="/sobre-el-proyecto">Sobre
      el proyecto</a>
      <a [ngClass]="{'current-link' : compareRouterValue('/calculadora') || compareRouterValue('/calculadora-intro')}"
         routerLink="/calculadora-intro">Calculadora TCO</a>
      <a [ngClass]="{'current-link' : compareRouterValue('/faq')}" routerLink="/faq">Preguntas y Respuestas</a>
<!--      <a [ngClass]="{'current-link' : compareRouterValue('/novedades')}" routerLink="/novedades">Novedades</a>-->
      <a [ngClass]="{'current-link' : compareRouterValue('/contacto')}" routerLink="/contacto">Contacto</a>
    </div>
  </nav>
</header>
